import { Alert, Box } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const StyledAlert = styled(Alert)`
  display: flex;
  align-items: center;
  padding: 2px 16px;
  width: 100%;

  .MuiAlertTitle-root {
    margin: 0;
  }
`;

export const NoRiderAssistantContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
